

export const regexValidators = {
	emailAddress: /^([\w\d\.\-_]+@[\w\.\-]+)$/, // eslint-disable-line
	phoneNumber: /^[0-9]{7,12}$/, // eslint-disable-line
	personName: /^[a-zA-Z\s]+$/, // eslint-disable-line
	companyName: /^[a-zA-Z0-9\s&áéíóú\.]+$/, // eslint-disable-line
};